import React, {useEffect, useState} from 'react';
import {Steps, StepsProvider, useSteps} from "react-step-builder";
import Api from '../services/api/api';
import BucketSorter from "./questions/BucketSorter";
import Checkboxes from "./questions/Checkboxes";
import Emoji from "./questions/Emoji";
import TheEnd from "./TheEnd";
import Error from "./questions/Error";
import Heatmap from './questions/Heatmap';
import NitroPageHeading from './parts/NitroPageHeading';
import Radio from "./questions/Radio";
import Radar from "./questions/Radar";
import Range from "./questions/Range";
import PrioritySorter from "./questions/PrioritySorter";
import Textarea from "./questions/Textarea";
import Textinput from "./questions/Textinput";
import soundNext from '../sounds/next.mp3';
import ScrollToTop from "./ScrollToTop";

const Survey = ({sessionID, uid, qData}) => {

    return (

      <StepsProvider>
        <MySteps sessionID={sessionID} uid={uid} qData={qData} />
      </StepsProvider>

    );

}

const MySteps = ({sessionID, uid, qData}) => {

  const availablePageStyles = ['pageStyle1', 'pageStyle2', 'pageStyle3'];

  const [pageStyle, setPageStyle] = useState(1);
  const [wiperStyle, setWiperStyle] = useState(1);
  const [transActive, setTransActive] = useState(1);

  // see docs at https://www.npmjs.com/package/react-step-builder
  const { prev, next, jump, total, current, progress } = useSteps();

  let animateToNext = (data) => {
    data.sessionId = sessionID;

    let resourceApi = new Api();
    resourceApi.post('result/' + uid, data)
      .then(res => res.json())
      .then((response) => {
        //console.log('response from api', response);
        if (response.complete == 'RESULT_SAVED') {
          console.log('Result saved:', response.result)
        } else {
          console.warn('no response');
        }
      })
      .catch((error) => {
        console.warn(error);
      });


    // get next style
    let nextStyle = (pageStyle === availablePageStyles.length-1) ? // last one
      0 : 1 + pageStyle; // revert to 1st or else get next

    setWiperStyle(nextStyle); // makes the bomb the same colour as the next screen
    setTransActive(true); // add active class to bomb, which tirggers css animation
    // sound below works well but JW disliked it
    // new Audio(soundNext).play();
    setTimeout(function() {
      next(); // display next page
      setPageStyle(nextStyle); // change page bg colour
    }, 1000);
    setTimeout(function () {
      setTransActive(false); // remove active class
    }, 2600); // allow time for css animation to complete

  }

  const nitroSteps = qData.questions.map((q) => {
    let ComponentName=Error
    if (q.type === 'bucket_sort')
      ComponentName =BucketSorter
    else if (q.type === 'checkbox')
      ComponentName=Checkboxes
    else if (q.type === 'emoji')
      ComponentName=Emoji
    else if (q.type === 'heat_map')
      ComponentName=Heatmap
    else if (q.type === 'radio')
      ComponentName=Radio
    else if (q.type === 'radar')
      ComponentName=Radar
    else if (q.type === 'range')
      ComponentName=Range
    else if (q.type === 'priority_sort')
      ComponentName=PrioritySorter
    else if (q.type === 'text')
      ComponentName = Textinput
    else if (q.type === 'textarea')
      ComponentName=Textarea

    return <div key={q.id}>
            <ScrollToTop />
            <div className="container lg">
              <div className="min-h-screen mx-auto flex flex-col px-6 md:px-8 pb-8 pt-8 md:pt-24 md:pb-16">
                <NitroPageHeading heading1={q.text} heading2={q.hint} />
                <ComponentName qData={q} pageStyle={pageStyle+1} theme={qData.theme} nextStep={animateToNext} />
              </div>
            </div>
          </div>
    }
  );

  let wiperClass = availablePageStyles[wiperStyle];
  wiperClass += (transActive)?' active':'';

  useEffect(() => {
    setTransActive(false);

  }, []); // the square brackets here are important to make this run on first load only

  return (
    <div className={`releative ${availablePageStyles[pageStyle]}`}>
      <div id='bomb' className={wiperClass}></div>
      <Steps>
        {nitroSteps}
        <TheEnd theme={qData.theme} />
      </Steps>

      <div id="steps-progress" className="absolute bg-nitro-slate rounded invisible md:visible">
        <div className="px-6 py-1 text-white text-xs">{current} of {total}</div>
        <div className="bar" style={{
          'width': `${progress * 100}` + '%'
        }}></div>
      </div>
    </div>
  );
};

export default Survey;
